import api from './axios';

const buildFormData = (fields, file, fileField = 'file') => {
  const formData = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
    }
  });
  if (file) formData.append(fileField, file);
  return formData;
};

export const fetchSalonProfile = () => api.get('/salon/profile').then((r) => r.data);

export const updateSalonProfile = (fields, logoFile) =>
  api
    .put('/salon/profile', buildFormData(fields, logoFile), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);

export const fetchBranches = () => api.get('/salon/branches').then((r) => r.data);

export const createBranch = (fields, coverFile) =>
  api
    .post('/salon/branches', buildFormData(fields, coverFile), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);

export const updateBranch = (branchId, fields, coverFile) =>
  api
    .put(`/salon/branches/${branchId}`, buildFormData(fields, coverFile), {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);

export const deleteBranch = (branchId) =>
  api.delete(`/salon/branches/${branchId}`).then((r) => r.data);

export const fetchBranchGallery = (branchId) =>
  api.get(`/salon/branches/${branchId}/gallery`).then((r) => r.data);

export const uploadBranchGallery = (branchId, files, onProgress) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('images', file));
  return api
    .post(`/salon/branches/${branchId}/gallery`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    })
    .then((r) => r.data);
};

export const deleteGalleryImage = (imageId) =>
  api.delete(`/salon/gallery/${imageId}`).then((r) => r.data);

export const reorderGallery = (items) =>
  api.put('/salon/gallery/reorder', { items }).then((r) => r.data);

export const updateGalleryCaption = (imageId, caption) =>
  api.put(`/salon/gallery/${imageId}/caption`, { caption }).then((r) => r.data);

export const fetchBankAccounts = () => api.get('/salon/bank-accounts').then((r) => r.data);

export const createBankAccount = (body) =>
  api.post('/salon/bank-accounts', body).then((r) => r.data);

export const updateBankAccount = (accountId, body) =>
  api.put(`/salon/bank-accounts/${accountId}`, body).then((r) => r.data);

export const deleteBankAccount = (accountId) =>
  api.delete(`/salon/bank-accounts/${accountId}`).then((r) => r.data);
